<template>
  <div class="box">
    <div class="select">
      <form action="/">
        <van-search v-model="enterpriseName" background="#fff" @cancel="onCancel" placeholder="搜索企业名称/店铺名称" show-action />
      </form>
    </div>
    <div v-if="showNone1">
      <div class="box2" v-if="!showNone">
        <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText"
        :immediate-check="false"
        @load="onLoad"
        >
        <ul>
          <li class="line_bottom" v-for="(item,index) in dataList" :key="index" @click="goScoreDetails(index)">
            <div class="score">
              <div class="left">
                <!-- <div class="businessName">{{item.name}}</div> -->
                <div class="businessName" :class="{businessNameWidth: !item.isBlackList && !item.isSupervision}">
                  <span>{{item.name.slice(0, item.name.indexOf(enterpriseName))}}</span>
                  <span class="highlight">{{item.name.slice(item.name.indexOf(enterpriseName),item.name.indexOf(enterpriseName)+enterpriseName.length)}}</span>
                  <span>{{item.name.substr(item.name.indexOf(enterpriseName)+enterpriseName.length)}}</span>
                </div>
                <!-- <van-tag class="tag" plain type="danger" v-if="item.isBlackList">黑名单</van-tag>
                <van-tag class="tag" plain type="danger" v-else-if="item.isSupervision">重点关注</van-tag> -->
                <div class="tag line_border_red" v-if="item.isBlackList">黑名单</div>
                <div class="tag line_border_red" v-else-if="item.isSupervision">重点关注</div>
              </div>
              <div class="right" v-show='item.score'>{{item.score > -1 ? item.score : ''}}分</div>
              <div class="right" v-show='!item.score&&item.ratingStatusName==="未评分"'>待评分</div>
              <div class="right" v-show='!item.score&&item.ratingStatusName==="已评分"'>已评分</div>
              <!-- <div class="right" v-show='!item.score'>{{item.ratingStatusName}}</div> -->
            </div>
            <div class="adress">{{item.address}}</div>
          </li>
        </ul>
        </van-list>
      </div>
    </div>
    <div class="tipsBox" v-if="isShowTips">
      <img class="tipsImgBox" src="../../../../assets/image/ic_wusousuo@3x.png" alt="">
      <p class="tipsText">当前搜索无结果</p>
      <p>请核对信息后进行搜索</p>
    </div>
  </div>
</template>
<script>
    import api from '../../../../service/modules/integrity';
    export default {
        data () {
            return {
                loading: false,
                finished: false,
                finishedText: '',
                enterpriseName: '',
                pageSize: 20,
                pageIndex: 1,
                dataList: [], // 获取数据
                showNone: true,
                showNone1: false,
                type: 'all',
                isShowTips: false
            };
        },
        watch: {
            'enterpriseName' (val) {
                this.pageIndex = 1
                this.enterpriseName = val
                if (val === '') {
                    this.showNone1 = false
                } else {
                    this.showNone1 = true
                }
                if (val === '') {
                    this.isShowTips = false
                }
                this.dataList = []
                this.getList();
            }
        },
        methods: {
            onLoad () {
                this.pageIndex++
                let parm = {
                    pageSize: this.pageSize,
                    pageIndex: this.pageIndex,
                    type: this.type,
                    enterpriseName: this.enterpriseName
                };
                api.getEnterpriseList(parm).then(res => {
                    if (res.ret === 0) {
                        let arr = res.data.list
                        if (arr.length > 0) {
                            this.dataList = this.dataList.concat(arr)
                            this.finished = false
                        } else {
                            this.finished = true
                            this.finishedText = '没有更多了'
                        }
                        this.loading = false
                    }
                });
            },
            goScoreDetails (e) {
                this.$router.push({
                    path: 'scoreDetails',
                    query: {
                        id: this.dataList[e].id
                    }
                });
            },
            onCancel () {
                this.enterpriseName = ''
                this.$router.go(-1)
            },
            getList () {
                let parm = {
                    pageSize: this.pageSize,
                    pageIndex: this.pageIndex,
                    type: this.type,
                    enterpriseName: this.enterpriseName
                };
                api.getEnterpriseList(parm).then(res => {
                    if (res.ret === 0) {
                        if (res.data.list.length > 0) {
                            this.showNone = false
                        } else {
                            this.showNone = true
                        }
                        let arr = res.data.list
                        if (arr.length > 0) {
                            this.dataList = this.dataList.concat(arr)
                            this.finished = false
                        } else {
                            this.finished = true
                            this.finishedText = '没有更多了'
                        }
                        this.loading = false
                        if (res.data.list.length === 0 && this.dataList.length === 0) {
                            this.isShowTips = true
                        } else {
                            this.isShowTips = false
                        }
                    }
                });
            }
        }
    };
</script>
<style lang="less" scoped>
.box {
  width: 100%;
  height: 100%;
  background: #fbfbfb;
  box-sizing: border-box;
  .select {
    padding-top: 3px;
    padding-right: 8px;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 60px;
    line-height: 60px;
    background: #fff;
    z-index: 999;
  }
  .box2 {
    width: 100%;
    height: 100%;
    padding: 12px;
    padding-top: 72px;
    ul {
      box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
      border-radius:3px;
      width: 100%;
      margin-top: 7px;
      background-color: #fff;
      li:last-child{
        border-bottom: none;
      }
      li {
        list-style: none;
        box-sizing: border-box;
        padding: 16px 16px 12px 16px;
        font-size: 14px;
        overflow: hidden;
        .score {
          color: #333;
          display: flex;
          justify-content: space-between;
          font-weight: Medium;
          overflow: hidden;
          .left {
            display: flex;
            justify-content: left;
            .businessName {
              line-height: 18px;
              font-size: 14px;
              font-weight: bold;
              max-width: 200px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              .highlight{
                color: @base-color;
                font-weight: bold;
              }
            }
            .businessNameWidth{
              max-width: 260px;
            }
            .tag {
              line-height: 18px;
              font-size: 12px;
              height: 18px;
              margin-left: 4px;
              -webkit-transform: scale(0.84);
              margin: 0px 3px 0 3px;
              padding: 0 3px 2px 3px;
              text-align: center;
              color: #ff4d4d;
            }
            .callout {
              display: inline-block;
              height: 18px;
              line-height: 18px;
              margin-top: -1px;
              margin-left: 4px;
              padding: 0 8px;
              box-sizing: border-box;
              border: 1px solid #ff4d4d;
              color: #ff4d4d;
              font-size: 10px;
              font-weight: Regular;
            }
          }
          .right{
            font-size: 14px;
            font-weight: 600;
            line-height: 16px;
          }
        }
        .adress {
          color: #666;
          margin-top: 6px;
          width: 80%;
          line-height: 20px;
          font-size: 14px;
        }
      }
    }
  }
  .tipsBox{
    width: 140px;
    color: #999999;
    font-size: 14px;
    text-align: center;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);

    .tipsImgBox{
      width: 74px;
      height: 62px;
      margin: 0 auto;
      margin-bottom: 15px;
      display: block;
    }

    .tipsText{
      margin-bottom: 10px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-size:14px;
    }
  }
}
</style>

<style lang="less">
.van-search--show-action{
  background: #fff;
}
.van-search__content {
  border: 1px solid #eeeeee;
  background: #fff;
  .van-search--show-action{
    padding-right: 40px !important;
  }
}
.van-search__action{
  padding: 0 8px 0 20px;
}
</style>
